import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cffdefa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dash-reg-skelet" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"dash-reg-skelet__avatar\" data-v-cffdefa6></div><div class=\"dash-reg-skelet__name\" data-v-cffdefa6></div><div class=\"dash-reg-skelet__shift\" data-v-cffdefa6></div><div class=\"dash-reg-skelet__shift\" data-v-cffdefa6></div><div class=\"dash-reg-skelet__amount\" data-v-cffdefa6></div><div class=\"dash-reg-skelet__tag\" data-v-cffdefa6></div>", 6)
const _hoisted_8 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_8))
}